import { render, staticRenderFns } from "./WatchlistLink.vue?vue&type=template&id=05eca4f1&scoped=true&"
import script from "./WatchlistLink.vue?vue&type=script&lang=js&"
export * from "./WatchlistLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eca4f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05eca4f1')) {
      api.createRecord('05eca4f1', component.options)
    } else {
      api.reload('05eca4f1', component.options)
    }
    module.hot.accept("./WatchlistLink.vue?vue&type=template&id=05eca4f1&scoped=true&", function () {
      api.rerender('05eca4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/watchlist/WatchlistLink.vue"
export default component.exports